import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import "../../css/toastr.css";
import { styles } from "./styles";

class SnackbarComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openSnackbar: this.props.openSnackbar || false,
      color: "white",
      messageInfo: {
        type: "",
      },
    };
  }
  queue = [];

  componentWillMount() {
    this.props.onRef(null);
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  handleClick = (message, type) => {
    this.queue.push({
      message,
      key: new Date().getTime(),
      type: type || "success",
    });
    // if (this.state.openSnackbar) {
    //     this.setState({ openSnackbar: false });
    // } else {
    //     this.processQueue();
    // }

    this.processQueue();
  };

  processQueue = () => {
    if (this.queue.length > 0) {
      let _this = this;
      this.setState(
        {
          messageInfo: this.queue.shift(),
          type: this.queue.shift(),
          openSnackbar: true,
        },
        function () {
          setTimeout(function () {
            _this.handleClose();
          }, 3000);
        }
      );
    }
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openSnackbar: false });
  };

  handleExited = () => {
    this.processQueue();
  };

  render() {
    const { classes, t, snackbar } = this.props;
    const { messageInfo } = this.state;
    const { key } = messageInfo;
    let openSnackbar = snackbar.open || false;
    if (openSnackbar) {
      return (
        <div
          className={classes.containerToastr + " toast-top-right"}
          key={key}
          id="toast-container"
        >
          <div
            className={`toast toast-${
              snackbar.type ? snackbar.type : "success"
            }`}
            aria-live="polite"
          >
            <div className="toast-title">{t("notice")}</div>
            <div className="toast-message">{t(snackbar.content)}</div>
          </div>
        </div>
      );
    } else return <div className="toast-hide"></div>;
  }
}

SnackbarComponent.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  snackbar: state.application.snackbar,
});

const mapDispatch = (dispatch) => ({
  userDispatch: dispatch.user,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(SnackbarComponent)
  )
);
